import { FC } from 'react';
import { cn } from 'utils/cn';

interface IHamburguerIcon {
  open?: boolean;
}

const HamburguerIcon: FC<IHamburguerIcon> = ({ open }) => {
  return (
    <span className={cn('flex scale-[1.5] items-center gap-2')}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="15"
        fill="none"
        viewBox="0 0 18 15"
      >
        <path
          d="M1.125 0C0.50368 0 0 0.50368 0 1.125C0 1.74632 0.50368 2.25 1.125 2.25H16.875C17.4963 2.25 18 1.74632 18 1.125C18 0.50368 17.4963 0 16.875 0H1.125Z"
          fill="#3B7CC9"
          className={cn('animate-[cubic-bezier(.61,1,.88,1)] transition-transform duration-200')}
          style={{
            transform: open
              ? 'rotate(45deg) translate(1px,-1px)'
              : 'rotate(0deg) translate(0px,0px)'
          }}
        />
        <path
          d="M1.125 6C0.50368 6 0 6.50368 0 7.125C0 7.74632 0.50368 8.25 1.125 8.25H16.875C17.4963 8.25 18 7.74632 18 7.125C18 6.50368 17.4963 6 16.875 6H1.125Z"
          fill="#3B7CC9"
          className={cn(
            'transition-opacity duration-100 ease-in',
            open ? 'opacity-0' : 'opacity-100'
          )}
        />
        <path
          d="M1.125 12C0.50368 12 0 12.5037 0 13.125C0 13.7463 0.50368 14.25 1.125 14.25H16.875C17.4963 14.25 18 13.7463 18 13.125C18 12.5037 17.4963 12 16.875 12H1.125Z"
          fill="#3B7CC9"
          style={{
            transform: open
              ? 'rotate(-45deg) translate(-9px, -3px)'
              : 'rotate(0deg) translate(0px, 0px)'
          }}
          className={cn('animate-[cubic-bezier(.61,1,.88,1)] transition-transform duration-200')}
        />
      </svg>
    </span>
  );
};

export default HamburguerIcon;
